export const getReadingTime = text => {
  if (!text) {
    return null;
  }

  const wpm = 225;
  const words = text.replace(/(<([^>]+)>)/ig, '').trim().split(/\s+/).length;

  return Math.ceil(words / wpm);
};
